<template>
  <Layout>
    <template #header>
      <div class="fl-header">
        <Heading v-if="heading" class="fl-heading">
          {{ heading }}
        </Heading>
        <Subheading v-if="subheading" class="fl-subheading">
          {{ subheading }}
        </Subheading>
      </div>
    </template>

    <template #default>
      <div class="fl-main">
        <FormError v-if="!!error" :error="error" />
        <slot name="default" />
      </div>
    </template>
  </Layout>
</template>

<script>
import Heading from '../typography/Heading2.vue'
import Subheading from '../typography/Subheading2.vue'
import Layout from './Layout.vue'
import FormError from './FormError.vue'

export default {
  components: {
    Layout,
    Heading,
    Subheading,
    FormError,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    subheading: {
      type: String,
      required: true,
    },
    error: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.fl-header {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-gap-2;
}

.fl-heading {
  /* Base */
  @apply tw-max-w-[256px];

  /* Desktop */
  @apply lg:tw-max-w-[580px];
}

.fl-subheading {
  /* Base */
  @apply tw-max-w-[200px];

  /* Desktop */
  @apply lg:tw-max-w-none;
}

.fl-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-flex-1 tw-mx-2 tw-mt-5;
}
</style>
